import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TUserListApiResponse } from '../../../../apis/users/users.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getUserDetailsListKey = 'get-user-details-list';

export const useUserDetailsListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TUserListApiResponse, TQueryError>
): UseQueryResult<TUserListApiResponse, TQueryError> => {
  const { getUsers } = useUsersService();

  return useQuery<TUserListApiResponse, TQueryError>({
    queryKey: [getUserDetailsListKey, params],
    queryFn: () => getUsers(params),
    enabled: true,
    ...options,
  });
};
